import { t } from '@core/i18n';

export enum Month {
  January = 1,
  February = 2,
  March = 3,
  April = 4,
  May = 5,
  June = 6,
  July = 7,
  August = 8,
  September = 9,
  October = 10,
  November = 11,
  December = 12,
}

export enum MonthQuarter {
  Q1 = 13,
  Q2 = 14,
  Q3 = 15,
  Q4 = 16,
}

export const getMonthQuarterLabelsMap = (): Record<number, string> => ({
  [Month.January]: t('january'),
  [Month.February]: t('february'),
  [Month.March]: t('march'),
  [Month.April]: t('april'),
  [Month.May]: t('may'),
  [Month.June]: t('june'),
  [Month.July]: t('july'),
  [Month.August]: t('august'),
  [Month.September]: t('september'),
  [Month.October]: t('october'),
  [Month.November]: t('november'),
  [Month.December]: t('december'),
  [MonthQuarter.Q1]: t('q1'),
  [MonthQuarter.Q2]: t('q2'),
  [MonthQuarter.Q3]: t('q3'),
  [MonthQuarter.Q4]: t('q4'),
});
